<template>
  <div class="account">
    <ValidationObserver ref="observer">
      <admin-layout title="My account">
        <form v-if="!isLoading" v-on:submit.prevent="editSelf" class="signin">
          <ValidationProvider
            ref="email"
            rules="required"
            v-slot="{ errors, valid, changed }"
          >
            <bg-field
              :error="errors && errors[0]"
              label="First name"
              name="first_name"
            >
              <bg-input
                :error="errors && errors[0]"
                name="first_name"
                :valid="changed && valid"
                v-model="user.first_name"
              />
            </bg-field>
          </ValidationProvider>
          <ValidationProvider
            ref="email"
            rules="required"
            v-slot="{ errors, valid, changed }"
          >
            <bg-field
              :error="errors && errors[0]"
              label="Last name"
              name="last_name"
            >
              <bg-input
                :error="errors && errors[0]"
                name="last_name"
                :valid="changed && valid"
                v-model="user.last_name"
              />
            </bg-field>
          </ValidationProvider>
          <ValidationProvider
            ref="email"
            rules="required|email"
            v-slot="{ errors, valid, changed }"
          >
            <bg-field :error="errors && errors[0]" label="Email" name="email">
              <bg-input
                :error="errors && errors[0]"
                name="email"
                :valid="changed && valid"
                v-model="userState.user.email"
                :disabled="true"
              />
            </bg-field>
          </ValidationProvider>
          <bg-field label="Role" name="role">
            <bg-input
              class="uppercase"
              name="role"
              v-model="roles[userState.user.role]"
              :disabled="true"
            />
          </bg-field>
          <bg-button text="Save" type="submit" :isLoading="isPosting" />
        </form>
        <div class="action-container">
          <bg-button
            class="signin-button"
            variant="secondary"
            vari
            text="Log out"
            @click="deleteToken"
          />
        </div>
      </admin-layout>
    </ValidationObserver>
  </div>
</template>

<style scoped>
.account {
  display: flex;
  justify-content: space-between;
}
.display {
  display: none;
}
.uppercase {
  text-transform: capitalize;
}
.signin-button {
  margin-top: 20px;
}
</style>

<script>
import AdminLayout from "@/layouts/admin";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import BgButton from "@/components/bg-button";
import { mapState } from "vuex";
import API from "@/api";

export default {
  name: "account",
  components: {
    BgButton,
    AdminLayout,
    BgField,
    BgInput,
  },
  data() {
    return {
      isPasswordChanging: false,
      isPosting: false,
      isLoading: true,
      roles: {
        company_admin: "Admin",
        company_member: "Member",
        admin: "Super Admin",
        demo: "Demo User",
      },
      user: {
        first_name: "",
        last_name: "",
      },
    };
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
    }),
  },
  async mounted() {
    this.isLoading = true;
    const data = await API.user.getUser(this.userState.user.id);
    this.user = {
      ...this.user,
      first_name: data.profile.first_name,
      last_name: data.profile.last_name,
    };
    this.isLoading = false;
  },
  methods: {
    deleteToken() {
      this.$store.dispatch("logout").then(() => this.$router.push("/signup"));
    },
    async editSelf() {
      const res = await this.$refs.observer.validate();
      if (res) {
        this.isPosting = true;
        const payload = {
          profile: {
            first_name: this.user.first_name,
            last_name: this.user.last_name,
          },
        };
        const data = await API.user.updateUser(this.userState.user.id, payload);
        this.$store.dispatch("changeName", data);
        this.isPosting = false;
      }
    },
  },
};
</script>
